var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"anonymous-short",attrs:{"to":{ name: 'AnonymousUpgrade' }}},[_vm._v("\n\t\tComplétez votre inscription pour bénéficier de toutes les fonctionnalités Patrimoffice\n  ")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-544dffa0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ForceCompleteProfileBanner.vue
// module id = null
// module chunks = 